import { Box, Grid, Typography } from "@mui/material";
import ContactLink from "components/common/ContactLink";
import Maybe from "components/common/Maybe";
import EnvelopeIcon from "components/icons/EnvelopeIcon";
import PhoneIcon from "components/icons/PhoneIcon";
import WebIcon from "components/icons/WebIcon";

interface Props {
  agent: ContentfulAgent;
}

const NeedHelp = ({ agent }: Props): JSX.Element => {
  const linkIconWrapperStyling = {
    height: "40px",
    width: "40px",
    aspectRatio: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const linkWrapperStyling = {
    padding: "0 20px 0 10px",
    minHeight: "52px",
    // Side by side the links are wider than a phone, and an email address or a
    // web address has to be allowed to wrap once they stack.
    width: { xs: "100%", md: "auto" },
    maxWidth: "100%",
    "& span": { overflowWrap: "anywhere" },
  };

  return (
    <Grid
      sx={{
        width: "100%",
        background:
          "radial-gradient(53.03% 321.42% at 48.22% 100%, #FFFFFF 0%, #E7EBF0 100%)",
        backdropFilter: "blur(47.5px)",
      }}
      direction="column"
      alignItems="center"
      gap={2}
      paddingY={{ xs: "48px", md: "84px" }}
      paddingX={{ xs: "20px", md: 0 }}
    >
      <Grid item>
        <Typography
          variant="h2"
          marginBottom={"24px"}
          textAlign={"center"}
          fontSize={{ xs: "26px", md: "36px" }}
          fontWeight={400}
        >
          Need some help?
        </Typography>
      </Grid>

      <Grid
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
          flexWrap: "wrap",
          gap: "18px",
          justifyContent: "center",
          width: "100%",
          maxWidth: "640px",
        }}
      >
        <ContactLink
          href={`tel:${agent.phone}`}
          text={agent.phone}
          sx={linkWrapperStyling}
        >
          <Box sx={linkIconWrapperStyling}>
            <PhoneIcon />
          </Box>
        </ContactLink>
        <Maybe test={agent.phoneSecondary}>
          <ContactLink
            href={`tel:${agent.phoneSecondary}`}
            text={agent.phoneSecondary}
            sx={linkWrapperStyling}
          >
            <Box sx={linkIconWrapperStyling}>
              <PhoneIcon />
            </Box>
          </ContactLink>
        </Maybe>
        <ContactLink
          href={`mailto:${agent.email}`}
          text={agent.email}
          sx={linkWrapperStyling}
        >
          <Box sx={linkIconWrapperStyling}>
            <EnvelopeIcon />
          </Box>
        </ContactLink>
        <ContactLink
          href={agent.mtiWebpage}
          text={agent.mtiWebpage}
          target="_blank"
          sx={linkWrapperStyling}
        >
          <Box sx={linkIconWrapperStyling}>
            <WebIcon />
          </Box>
        </ContactLink>
      </Grid>
    </Grid>
  );
};

export default NeedHelp;
